import { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Typography, useMediaQuery, Popover, ListItem, List, Button } from '@mui/material';
// assets
import ClockIcon from '../../../../assets/images/dashboard/RecentIcon.svg';
import LocationIcon from '../../../../assets/images/dashboard/LocationIcon.svg';
import PeopleGroupIcon from '../../../../assets/images/dashboard/PeopleGroupIcon.svg';
import DetailViewIcon from '../../../../assets/images/dashboard/DetailViewIcon.svg';
import { MENU_OPEN, SET_IS_CALENDAR_FROM_EDIT_ADD_AND_DELETE } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';

// import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import { useLazyQuery } from '@apollo/client';
import { GET_UPCOMING_EVENT } from 'schemas/query';
import { formatDateRange, formatDateTODayHHMMM } from 'helper/date.helper';
import { capitalizeFirstLetter } from 'helper/string.helper';
import { setUpcomingEventCentral } from 'store/Calendar/actions';
// ==============================|| NOTIFICATION ||============================== //

const HelpSectionSection = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { companyData, isReloadCalendar, isFromAddEditAndDelete } = useSelector((state) => state.customization);
    const [getUpcomingEvent] = useLazyQuery(GET_UPCOMING_EVENT, {
        variables: {
            eventInput: { companyId: companyData._id }
        },
        skip: !companyData._id
    });

    const [upcomingEvent, setUpcomingEvent] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const seeMoreCalendarView = () => {
        setAnchorEl(null);
        dispatch({ type: MENU_OPEN, id: 'dashboard' });
        dispatch({ type: SET_IS_CALENDAR_FROM_EDIT_ADD_AND_DELETE, isFromAddEditAndDelete: false });
        dispatch({ type: setUpcomingEventCentral, upcomingEventCentral: { ...upcomingEvent, id: upcomingEvent._id } });
        navigate('calendar');
    };
    const navigateToCalendarSection = () => {
        setAnchorEl(null);
        dispatch({ type: MENU_OPEN, id: 'dashboard' });
        dispatch({ type: setUpcomingEventCentral, upcomingEventCentral: null });
        navigate('calendar');
    };
    const getUpcomingEventApiCall = useCallback(async () => {
        try {
            const response = await getUpcomingEvent({
                variables: {
                    eventInput: {
                        companyId: companyData?._id
                    }
                }
            });
            const { getUpcomingCompanyEvent } = response.data;
            const { upcomingEvent } = getUpcomingCompanyEvent;
            setUpcomingEvent(upcomingEvent);
            if (upcomingEvent && !isFromAddEditAndDelete)
                dispatch({ type: setUpcomingEventCentral, upcomingEventCentral: { ...upcomingEvent, id: upcomingEvent._id } });
        } catch (e) {
            console.log(e);
        }
    }, [companyData, isReloadCalendar, isFromAddEditAndDelete]);

    useEffect(() => {
        if (companyData?._id) getUpcomingEventApiCall();
    }, [companyData, isReloadCalendar]);

    const open = Boolean(anchorEl);
    const id = open ? 'upcoming-event' : undefined;
    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 3,
                    [theme.breakpoints.up('sm')]: {
                        ml: 2,
                        mr: 2
                    },
                    [theme.breakpoints.up('md')]: {
                        mr: 3
                    }
                    // [theme.breakpoints.up('lg')]: {
                    //     mr: 10
                    // }
                }}
                className={upcomingEvent ? 'has-upcoming-event' : ''}
            >
                <ButtonBase
                    sx={{ borderRadius: '12px' }}
                    disableRipple
                    className="header-icon-container"
                    // onClick={() => navigate('calendar')}
                >
                    <Avatar variant="rounded" className="header-icon" color="inherit" onClick={navigateToCalendarSection}>
                        <CalendarMonthSharpIcon />
                    </Avatar>

                    {upcomingEvent && (
                        <Box className="header-event-text" onClick={handleClick}>
                            <Typography
                                component="span"
                                style={{ fontSize: '12px', display: 'block', textAlign: 'left', color: '#fff', marginLeft: '16px' }}
                            >
                                {upcomingEvent?.title}
                            </Typography>
                            <Typography
                                component="span"
                                style={{ fontSize: '12px', display: 'block', textAlign: 'left', color: '#fff', marginLeft: '16px' }}
                            >
                                {capitalizeFirstLetter(formatDateTODayHHMMM(upcomingEvent?.date))}
                            </Typography>
                        </Box>
                    )}
                    {/* <span>Calendar</span> */}
                </ButtonBase>

                {upcomingEvent && (
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        mt={5}
                        className="upcoming-event-modal"
                    >
                        <Typography variant={'h2'} fontWeight={400} fontFamily={`'Poppins', 'sans-serif'`} sx={{ p: 2 }}>
                            {upcomingEvent?.title}
                        </Typography>
                        <List>
                            <ListItem>
                                <img src={ClockIcon} alt="clock" width="24" height="24" />
                                <Box>
                                    <Typography>
                                        {formatDateRange(
                                            upcomingEvent?.date,
                                            upcomingEvent?.allDay ? upcomingEvent?.endDate : upcomingEvent?.endTime,
                                            upcomingEvent?.allDay
                                        )}{' '}
                                    </Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <img src={LocationIcon} alt="clock" width="24" height="24" />
                                <Box>
                                    <Typography>{upcomingEvent?.location}</Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <img src={PeopleGroupIcon} alt="clock" width="24" height="24" />
                                <Box>
                                    <Typography>
                                        {capitalizeFirstLetter(
                                            upcomingEvent?.eventAttendies === 'both' ? 'All team' : upcomingEvent?.eventAttendies || ''
                                        )}
                                    </Typography>
                                </Box>
                            </ListItem>
                            <ListItem>
                                <img src={DetailViewIcon} alt="clock" width="24" height="24" />
                                <Box>
                                    <Button type="text" onClick={seeMoreCalendarView}>
                                        Show more
                                    </Button>
                                </Box>
                            </ListItem>
                        </List>
                    </Popover>
                )}
            </Box>
        </>
    );
};

export default HelpSectionSection;
